import React from 'react';
import { MyBusinessManagement } from '@/components/business';

export const MyBusinessPage: React.FC = () => {
  return <MyBusinessManagement />;
};
